import PortalViewsReport from "../../modules/reports/PortalViewsReport.vue";
import ContactEmergencyReport from "../../modules/reports/ContactEmergencyReport.vue";
import RouterViewRender from "../../utils/routes/router-view-render";
import { PermissionList } from "../../static-data/PermissionList";
import { IsAbleNavigation } from "../utils/is-able-navigation";

const ReportsRoutes = {
  path: "", 
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "relatorio-visualizacoes-portal",
      component: PortalViewsReport,
      beforeEnter: (to, from, next) =>
        IsAbleNavigation(to, from, next, PermissionList.REPORTS_MENU),
      meta: { requiresAuth: true },
    },
    {
      path: "relatorio-contato-emergencia", 
      component: ContactEmergencyReport,
      beforeEnter: (to, from, next) =>
        IsAbleNavigation(to, from, next, PermissionList.REPORTS_MENU),
      meta: { requiresAuth: true },
    },
  ],
};

export default ReportsRoutes;
